<template>
  <div id="contenedor-agregar-contrato-directorio">
    <v-form
      v-model="formularioValido"
      ref="agregarContratoDirectorio">
      <v-card>
        <v-card-title>
          Registrar directorio
          <v-spacer></v-spacer>
          <v-btn icon @click="cerrar">
            <v-icon class="secondary--text" large>highlight_off</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col
              cols="12"
              md="6">
              <custom-select
                v-model="directorio.tipo"
                label="Tipo"
                :items="listadoTipos"
                item-text="nombre"
                item-value="id"
                :rules="[mixReglas.requerido]">
              </custom-select>
            </v-col>
            <v-col
              cols="12"
              md="6">
              <custom-text-field
              v-model="directorio.organizacion"
              label="Organización (opcional)">
            </custom-text-field>
            </v-col>
            <v-col
              cols="12">
              <custom-text-field
              v-model="directorio.nombre"
              label="Nombre"
              :rules="[mixReglas.requerido]">
            </custom-text-field>
            </v-col>
            <custom-text-area
              v-model="directorio.puesto"
              label="Puesto"
              rows="2">
            </custom-text-area>
            <custom-text-area
              v-model="directorio.contacto"
              label="Datos de contacto"
              :rules="[mixReglas.requerido]"
              rows="3">
            </custom-text-area>
            <custom-date-picker
              v-model="directorio.fechaAlta"
              label="Fecha Alta"
              cols="6">
            </custom-date-picker>
            <custom-date-picker
              v-model="directorio.fechaBaja"
              label="Fecha Baja"
              cols="6">
            </custom-date-picker>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <custom-button
            @click="cerrar"
            tipo="formCancelar"
            label="Cancelar"
            class="mr-3">
          </custom-button>
          <custom-button
            @click="mixRegistrarDirectorio"
            :disabled="!formularioValido || enviandoFormulario"
            :loading="enviandoFormulario"
            tipo="formAceptar"
            label="Guardar">
          </custom-button>
        </v-card-actions>
      </v-card>
    </v-form>
  </div>
</template>

<script>
import CustomSelect from '@/components/inputs/sinColumnas/Select.vue';
import CustomTextField from '@/components/inputs/sinColumnas/TextField.vue';
import CustomTextArea from '@/components/inputs/TextArea.vue';
import CustomDatePicker from '@/components/inputs/DatePicker.vue';
import CustomButton from '@/components/buttons/Button.vue';
import mixContratoDirectorio from './mixContratoDirectorio';

export default {
  name: 'AgregarContratoDirectorio',
  mixins: [mixContratoDirectorio],
  components: {
    CustomSelect,
    CustomTextField,
    CustomTextArea,
    CustomButton,
    CustomDatePicker,
  },
  props: {
    idContrato: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      formularioValido: false,
      enviandoFormulario: false,
      directorio: {
        idContrato: this.idContrato,
        tipo: '',
        organizacion: '',
        nombre: '',
        contacto: '',
        puesto: '',
        fechaAlta: null,
        fechaBaja: null,
      },
    };
  },
  methods: {
    limpiarFormulario() {
      this.$refs.agregarContratoDirectorio.reset();
    },
    cerrar() {
      this.limpiarFormulario();
      this.$emit('cerrar');
    },
  },
  computed: {
    listadoTipos() {
      return [
        {
          id: 'cliente',
          nombre: 'Cliente',
        },
        {
          id: 'Contratista',
          nombre: 'Contratista',
        },
        {
          id: 'supervision-externa',
          nombre: 'Supervisión externa',
        },
        {
          id: 'otro',
          nombre: 'Otro',
        },
      ];
    },
  },
};
</script>

<style lang="scss">

</style>
